import React from "react";
import {
  callAuthSaveDebitInfo,
  callAuthSubmitDebitPayment,
  callAuthCheckPayoff,
} from "../../../actions/authPayment.actions";
import { connect } from "react-redux";
import { AuthPaymentDebit } from "../payment-forms/auth-payment-debit-form.component";
import { AuthDebitReview } from "../review/auth-debit-review-fields.component";
import { AuthPaymentDebitSummary } from "../summary/auth-payment-debit-summary.component";
import { usd } from "../../../utils/utils";
import moment from "moment";

const StandardDebitCardFlowComponent = (props) => {
  const currentForm = props.form["AuthPaymentDebit"];
  const debitResponse = props.authPayment.debitResponse;
  const paymentResponse = props.authPayment.paymentResponse;
  const payoffCheckResponse = props.authPayment.payoffCheck;
  const amountPastDueBetweenPayoffAndBalance = props.amountPastDueBetweenPayoffAndBalance;

  const isPrincipalOnly = props.paymentInfo.isPrincipalOnly;
  const hasSelectedPayoff = props.paymentInfo.hasSelectedPayoff;

  const { setProcessStep, processStep, selectedLoan, backToLoans } = props;

  switch (processStep) {
    case 1:
      return (
        <AuthPaymentDebit
          {...props.authPayment.selectedLoanAdditionalDetails}
          authPayment={props.authPayment}
          setProcessStep={setProcessStep}
          selectedLoan={selectedLoan}
          thisForm={currentForm}
          debitResponse={debitResponse}
          callAuthCheckPayoff={props.callAuthCheckPayoff}
          callAuthSaveDebitInfo={props.callAuthSaveDebitInfo}
          isPrincipalOnly={isPrincipalOnly}
          hasSelectedPayoff={hasSelectedPayoff}
          backToLoans={backToLoans}
          amountPastDueBetweenPayoffAndBalance={amountPastDueBetweenPayoffAndBalance}
        />
      );
    case 2:
      return (
        <AuthDebitReview
          paymentAppliedDate={moment(debitResponse.PostDate).format("MM/DD/YYYY")}
          paymentAccount={`${debitResponse.CardType} ${debitResponse.CardNumberLastFour}`}
          paymentAmount={usd.format(debitResponse.PaymentAmount)}
          paymentTotal={usd.format(debitResponse.PaymentAmount + debitResponse.FeeAmount)}
          fee={usd.format(debitResponse.FeeAmount)}
          selectedLoan={selectedLoan}
          setProcessStep={setProcessStep}
          callAuthSubmitDebitPayment={props.callAuthSubmitDebitPayment}
          paymentResponse={paymentResponse}
          isPayoff={payoffCheckResponse.PaymentTypeChangedToPayoff}
          backToLoans={backToLoans}
        />
      );
    case 3:
      return (
        <AuthPaymentDebitSummary
          paymentAppliedDate={moment(paymentResponse.PostDate).format("MM/DD/YYYY")}
          paymentAccount={`${paymentResponse.CardType} ${paymentResponse.CardNumberLastFour}`}
          paymentAmount={usd.format(paymentResponse.PaymentAmount)}
          paymentTotal={usd.format(paymentResponse.PaymentAmount + paymentResponse.FeeAmount)}
          isPayoff={payoffCheckResponse.PaymentTypeChangedToPayoff}
          fee={usd.format(paymentResponse.FeeAmount)}
          confirmationEmail={paymentResponse.EmailAddress}
          selectedLoan={selectedLoan}
          isPrincipalOnly={isPrincipalOnly}
          backToLoans={backToLoans}
        />
      );
    case 4:
      return <div>Step 4</div>;
    default:
      return <div>Something has gone wrong.</div>;
  }
};

const mapDispatchToProps = {
  callAuthSaveDebitInfo,
  callAuthSubmitDebitPayment,
  callAuthCheckPayoff,
};

const StandardDebitCardFlow = connect(null, mapDispatchToProps)(StandardDebitCardFlowComponent);

export default StandardDebitCardFlow;



// WEBPACK FOOTER //
// ./src/components/authenticated-payments/flow-components/standard-debit-flow.component.js